<template>
	<div class="chat-quick-reply" @click.stop="closeContextMenu">
		<div class="quick-reply-header">
			<span>快捷回复</span>
			<el-link type="primary" icon="el-icon-plus" @click="openEditor()">新增</el-link>
		</div>
		<div v-loading="loading" class="quick-reply-list">
			<div v-if="!loading && !items.length" class="quick-reply-empty">
				<i class="el-icon-chat-dot-round"></i>
				<span>暂未添加回复内容</span>
			</div>
			<div v-for="(item, index) in items" :key="item.id" class="quick-reply-item"
				:class="{ 'is-dragging': draggingIndex === index }" draggable="true"
				@click="selectReply(item)" @contextmenu.prevent.stop="openContextMenu(item, $event)"
				@dragstart="onDragStart(index, $event)" @dragover.prevent="onDragOver(index)" @dragend="onDragEnd">
				<div class="quick-reply-content">{{ item.content }}</div>
				<div class="quick-reply-actions">
					<i class="el-icon-edit" title="编辑" @click.stop="openEditor(item)"></i>
					<i class="el-icon-sort quick-reply-drag-handle" title="拖拽排序"></i>
				</div>
			</div>
		</div>
		<div v-if="contextMenu.visible" class="quick-reply-context-menu"
			:style="{ left: contextMenu.x + 'px', top: contextMenu.y + 'px' }" @click.stop="confirmContextDelete">
			<i class="el-icon-delete"></i>
			<span>删除</span>
		</div>
		<el-dialog v-dialogDrag :title="editingItem ? '编辑快捷回复' : '新增快捷回复'" :visible.sync="editorVisible"
			width="420px" append-to-body @closed="resetEditor">
			<el-input v-model="editorContent" type="textarea" :rows="5" maxlength="1000" show-word-limit
				placeholder="请输入快捷回复内容"></el-input>
			<span slot="footer">
				<el-button @click="editorVisible = false">取消</el-button>
				<el-button type="primary" :loading="saving" @click="saveReply">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'ChatQuickReply',
	data() {
		return {
			items: [],
			loading: false,
			saving: false,
			editorVisible: false,
			editorContent: '',
			editingItem: null,
			draggingIndex: -1,
			dragChanged: false,
			contextMenu: {
				visible: false,
				x: 0,
				y: 0,
				item: null
			}
		}
	},
	created() {
		this.loadReplies();
	},
	methods: {
		async loadReplies() {
			this.loading = true;
			try {
				const data = await this.$http({ url: '/quick-reply/list', method: 'GET' });
				this.items = Array.isArray(data) ? data : [];
			} finally {
				this.loading = false;
			}
		},
		selectReply(item) {
			this.$emit('select', item.content);
		},
		openEditor(item) {
			this.editingItem = item || null;
			this.editorContent = item ? item.content : '';
			this.editorVisible = true;
		},
		resetEditor() {
			this.editorContent = '';
			this.editingItem = null;
		},
		async saveReply() {
			const content = this.editorContent.trim();
			if (!content) {
				this.$message.warning('快捷回复内容不能为空');
				return;
			}
			this.saving = true;
			try {
				if (this.editingItem) {
					await this.$http({ url: '/quick-reply', method: 'PUT', data: { id: this.editingItem.id, content } });
					this.$set(this.editingItem, 'content', content);
				} else {
					const item = await this.$http({ url: '/quick-reply', method: 'POST', data: { content } });
					this.items.unshift(item);
				}
				this.editorVisible = false;
			} finally {
				this.saving = false;
			}
		},
		openContextMenu(item, event) {
			const rect = this.$el.getBoundingClientRect();
			this.contextMenu = {
				visible: true,
				x: event.clientX - rect.left,
				y: event.clientY - rect.top,
				item
			};
		},
		closeContextMenu() {
			this.contextMenu.visible = false;
		},
		confirmContextDelete() {
			const item = this.contextMenu.item;
			this.closeContextMenu();
			this.$confirm('确定删除这条快捷回复吗？', '删除确认', {
				type: 'warning',
				confirmButtonText: '删除',
				cancelButtonText: '取消'
			}).then(() => this.deleteReply(item)).catch(() => {});
		},
		async deleteReply(item) {
			this.deletingId = item.id;
			try {
				await this.$http({ url: `/quick-reply/${item.id}`, method: 'DELETE' });
				const index = this.items.indexOf(item);
				if (index > -1) this.items.splice(index, 1);
			} finally {
				this.deletingId = null;
			}
		},
		onDragStart(index, event) {
			this.draggingIndex = index;
			event.dataTransfer.effectAllowed = 'move';
		},
		onDragOver(index) {
			if (this.draggingIndex < 0 || this.draggingIndex === index) return;
			const moved = this.items.splice(this.draggingIndex, 1)[0];
			this.items.splice(index, 0, moved);
			this.draggingIndex = index;
			this.dragChanged = true;
		},
		async saveSort() {
			await this.$http({ url: '/quick-reply/sort', method: 'PUT', data: { ids: this.items.map(item => item.id) } });
		},
		async onDragEnd() {
			this.draggingIndex = -1;
			if (!this.dragChanged) return;
			this.dragChanged = false;
			try {
				await this.saveSort();
			} catch (e) {
				this.loadReplies();
			}
		}
	}
};
</script>

<style scoped lang="scss">
.chat-quick-reply { position: relative; height: 100%; padding: 12px 10px; background: #fff; box-sizing: border-box; }
.quick-reply-header { display: flex; align-items: center; justify-content: space-between; font-size: 16px; font-weight: 600; margin-bottom: 24px; }
.quick-reply-list { position: relative; height: calc(100% - 36px); overflow-y: auto; padding-right: 2px; }
.quick-reply-empty { position: absolute; top: 50%; left: 0; right: 0; display: flex; flex-direction: column; align-items: center; gap: 10px; color: #999; text-align: center; font-size: 13px; transform: translateY(-50%); }
.quick-reply-empty i { font-size: 30px; color: #c5cbd3; }
.quick-reply-item { display: flex; align-items: center; min-height: 54px; margin-bottom: 8px; padding: 8px 8px 8px 10px; border: var(--im-border); border-radius: 8px; background: #fff; cursor: pointer; box-sizing: border-box; transition: box-shadow .2s, opacity .2s; }
.quick-reply-item:hover { border-color: var(--im-color-primary); }
.quick-reply-item.is-dragging { opacity: .45; }
.quick-reply-content { flex: 1; min-width: 0; color: #333; font-size: 13px; line-height: 18px; word-break: break-all; white-space: pre-wrap; text-align: left; }
.quick-reply-actions { display: flex; align-items: center; gap: 10px; margin-left: 8px; color: #222; font-size: 17px; flex-shrink: 0; }
.quick-reply-actions i { cursor: pointer; }
.quick-reply-actions .quick-reply-drag-handle { cursor: grab; }
.quick-reply-actions .quick-reply-drag-handle:active { cursor: grabbing; }
.quick-reply-context-menu { position: absolute; z-index: 10; display: flex; align-items: center; gap: 4px; width: 88px; padding: 10px 14px; color: #f56c6c; background: #fff; border: 1px solid #ebeef5; border-radius: 8px; box-shadow: 0 2px 12px rgba(0, 0, 0, .12); box-sizing: border-box; cursor: pointer; }
.quick-reply-context-menu:hover { background: #fef0f0; }
</style>
